import {z} from "zod/v4-mini"

export type Distribution = "GGX" | "MULTI_GGX"
export const distributionSchema = z.enum(["GGX", "MULTI_GGX"])

export type SubsurfaceMethod = "BURLEY" | "RANDOM_WALK"
export const subsurfaceMethodSchema = z.enum(["BURLEY", "RANDOM_WALK"])
